import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';
import Routes from './Routes';
import { AuthProvider } from './contexts/AuthContext';
import { StripeProvider } from './contexts/StripeContext';

function App() {
  return (
    <AuthProvider>
      <StripeProvider>
        <BrowserRouter>
          <ErrorBoundary>
            <ScrollToTop />
            <Routes />
          </ErrorBoundary>
        </BrowserRouter>
      </StripeProvider>
    </AuthProvider>
  );
}

export default App;